import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ParametrosEnum } from 'src/app/shared/enums/parameters.enum';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { BinanceService } from '../../services/binance.service';
import { ParameterService } from '../../services/parameter.service';
import { SetUsdtRateComponent } from './set-usdt-rate/set-usdt-rate.component';
import { AdminEditPermissionsService } from 'src/app/shared/services/admin-edit-permissions.service';
@Component({
  selector: 'app-cripto-rate',
  templateUrl: './cripto-rate.component.html',
  styleUrls: ['./cripto-rate.component.sass'],
})
export class CriptoRateComponent implements OnInit {
  tasa: any;
  public currentPage = 1;
  public pageSize = 25;
  public totalItems = 0;
  public totalPages = this.totalItems / this.pageSize;

  displayedColumns: string[] = ['fecha', 'hora', 'tasa'];
  formCuenta: FormGroup | undefined = undefined;
  factorManual = 0;

  columns = [
    {
      columnDef: 'fecha',
      header: 'Fecha',
      cell: (element: any) =>
        `${this.datePipe.transform(element.createdAt, 'dd/MM/yyyy')}`,
    },
    {
      columnDef: 'hora',
      header: 'Hora',
      cell: (element: any) =>
        ` ${this.datePipe.transform(
          element.createdAt,
          'hh:mm a',
          'America/Santiago'
        )} `,
    },
    {
      columnDef: 'tasa',
      header: 'Tasa de Negociación',
      cell: (element: any) =>
        `${
          element.tasaUsdtClp ? parseFloat(element.tasaUsdtClp).toFixed(2) : ''
        } `,
    },
  ];
  dataSource: MatTableDataSource<any> | undefined;

  /** Candado de edición: en producción solo escribe el operador autorizado. */
  puedeEditar = false;

  constructor(
    private datePipe: DatePipe,
    private tasasService: BinanceService,
    private dialog: MatDialog,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private parameterService: ParameterService,
    private permisos: AdminEditPermissionsService,
  ) {
    this.initTasaValue();
  }
  async ngOnInit(): Promise<void> {
    this.aplicarPermisoEdicion(this.permisos.valorInicial);
    this.permisos.puedeEditar().then((puede) => this.aplicarPermisoEdicion(puede));

    await this.getFactorManual();
    this.formCuenta = this.fb.group({
      factorManual: [
        this.factorManual,
        [
          Validators.required,
          Validators.maxLength(3),
          this.greaterThanZeroValidator(),
        ],
      ],
    });
    this.aplicarPermisoEdicion(this.puedeEditar);
  }

  /**
   * Refleja el permiso en la pantalla: sin permiso, el campo del factor queda
   * deshabilitado además de los botones. El form se arma en `ngOnInit`, así
   * que puede todavía no existir cuando esto corre la primera vez.
   */
  private aplicarPermisoEdicion(puede: boolean): void {
    this.puedeEditar = puede;
    if (puede) {
      this.formCuenta?.enable({ emitEvent: false });
    } else {
      this.formCuenta?.disable({ emitEvent: false });
    }
  }

  greaterThanZeroValidator() {
    return (control: any) => {
      const value = +control.value;
      if (isNaN(value) || value <= 0) {
        return { greaterThanZero: true };
      }
      return null;
    };
  }
  actualizarFactorManual() {
    if (this.permisos.bloqueado(this.puedeEditar, 'Tu usuario no tiene permisos para modificar la tasa de negociación USDT.')) return;

    this.parameterService.saveParameter(
      ParametrosEnum.FACTOR_MANUAL,
      this.formCuenta?.get('factorManual')?.value
    );
  }

  async initTasaValue(): Promise<void> {
    const ref = this.spinner.start();
    this.tasa = await this.tasasService.getConversionData();
    const record = await this.tasasService.getConversionValueRecord(
      this.currentPage,
      this.pageSize
    );
    this.dataSource = new MatTableDataSource(record.query);
    this.totalItems = +record.count;
    this.totalPages = Math.ceil(this.totalItems / this.pageSize);
    this.spinner.stop(ref);
  }

  async getFactorManual() {
    let factorManualParameter = await this.parameterService.getParameter(
      ParametrosEnum.FACTOR_MANUAL
    );
    this.factorManual = factorManualParameter.valor || 0;
    this.formCuenta?.get('factorManual')?.setValue(this.factorManual);
  }

  async reload(): Promise<void> {
    this.currentPage = 1;
    this.initTasaValue();
    await this.getFactorManual();
  }

  onPageChange(event: any) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex + 1;
    this.initTasaValue();
  }

  async setRates() {
    if (this.permisos.bloqueado(this.puedeEditar, 'Tu usuario no tiene permisos para modificar la tasa de negociación USDT.')) return;

    this.dialog
      .open(SetUsdtRateComponent, {})
      .afterClosed()
      .subscribe((res) => {
        if (res && res === true) {
          this.initTasaValue();
        }
      });
  }
}
